/**
 * Created by andrey on 28.03.2024.
 */

const MetricsLogger = function () {
    this.batch = undefined;
    this.batches = [];

    this.addBatch = cleverapps.accumulate(0, () => this._addBatch());
    this.sendEvents = cleverapps.accumulate(0, () => this._sendEvents());

    if (!cleverapps.config.metricsApiURL) {
        console.log("Metrics logger disabled - metricsApiURL is not defined");
    }

    cleverapps.timeouts.setInterval(() => this.sendEvents(), MetricsLogger.SEND_EVENTS_INTERVAL);
    connector.platform.on("pause", () => this._sendEventsOnPause());
};

MetricsLogger.prototype.setPayer = function (payer) {
    this.payer = payer;
};

MetricsLogger.prototype.load = function () {
    const info = cleverapps.dataLoader.load(DataLoader.TYPES.METRICS) || {};
    this.batches = info.batches || [];

    // backward compatibility 07.07.26
    const events = info.events || {};

    for (const [key, params] of Object.entries(events)) {
        const eventName = params.eventName || key;
        delete params.eventName;
        this.logEvent(eventName, params);
    }
};

MetricsLogger.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.METRICS, {
        batches: this.batches
    });
};

/**
 * Base parameters are attached to every event automatically (see getBaseParameters):
 * source, registered, country, version, payer, channel, level, episode, language, location, user id.
 *
 * Do NOT concatenate any of the parameters above into the event name - pass them via params
 * and filter by the corresponding events table column instead.
 *
 * One row can represent a batch of events, so averages are computed later as sum(value) / sum(counter).
 *
 * @param {string} name - event name
 * @param {Object} [params] - custom params (each one is a typed column in the events table)
 * @param {number} [params.value=1] - the worth of the event: price, ad revenue, energy amount, etc.
 * @param {number} [params.counter=1] - how many times the event occurred
 * @param {string} [params.itemId] - which entity the event is about: fog id, offer name, mission type and other event details
 * @param {string} [params.productId] - monetization product id
 * @param {Object} [params.details] - free-form data stored as a JSON string in the details column; not a filterable column
 */
MetricsLogger.prototype.logEvent = function (name, params = {}) {
    if (!cleverapps.config.metricsApiURL) {
        return;
    }

    if (cleverapps.flags && cleverapps.flags.noLogEvents) {
        return;
    }

    if (name.length > 50) {
        cleverapps.throwAsync(`Event name length is more than 50 characters: ${name}`);

        name = name.substring(0, 50);
    }

    this.batch = this.batch || { names: [], params: [] };

    this.batch.names.push(name);
    this.batch.params.push(params);

    this.addBatch();

    if (MetricsLogger.IMPORTANT_EVENTS.includes(name) || cleverapps.user && cleverapps.user.isFirstSession()) {
        this.sendEvents();
    }
};

MetricsLogger.prototype._addBatch = function () {
    const batch = this.batch;
    this.batch = undefined;

    if (!batch) {
        return;
    }

    const events = batch.names.join(",");
    console.log(`Sending events - ${events}`);

    const data = this.getBaseParameters();
    data.events = events;
    data.params = batch.params;
    data.event = Date.now();

    this.batches.push(data);
    this.save();

    const eventsAmount = this.batches.reduce((acc, b) => acc + b.params.length, 0);
    if (eventsAmount >= 100) {
        this.sendEvents();
    }
};

MetricsLogger.prototype._sendEvents = function () {
    const batches = this.batches;

    if (batches.length === 0) {
        return;
    }

    cleverapps.RestClient.post(`${cleverapps.config.metricsApiURL}/events/`, { batches }, () => {
        // console.log("Success event - " + data.events.join(','));
    }, () => {
        console.log("Failure events", batches);
    }, {
        ignoreNoRest: cleverapps.config.importMode
    });

    this.batches = [];
    this.save();
};

MetricsLogger.prototype.sendEventsNow = function () {
    this._addBatch();
    this._sendEvents();
};

MetricsLogger.prototype._sendEventsOnPause = function () {
    if (cleverapps.flags.norest) {
        return;
    }

    this._addBatch();

    if (this.batches.length > 0 && connector.utils.postOnPause(`${cleverapps.config.metricsApiURL}/events/?pause=1`, { batches: this.batches })) {
        this.batches = [];
        this.save();
        cleverapps.dataLoader.processSaveQueue();
    }
};

MetricsLogger.prototype.getBaseParameters = function () {
    const params = {
        source: connector.info.source,
        registered: cleverapps.user ? cleverapps.user.registered : undefined,
        country: cleverapps.country ? cleverapps.country.getCountry() : undefined,
        version: cleverapps.config.version,
        payer: this.payer,
        channel: cleverapps.user ? cleverapps.user.channel : undefined,
        level: cleverapps.environment ? cleverapps.environment.levelNo : undefined,
        episode: cleverapps.environment ? cleverapps.environment.episodeNo : undefined,
        language: cleverapps.settings ? cleverapps.settings.language : undefined,
        location: cleverapps.environment ? cleverapps.environment.locationId : undefined,
        cheater: cleverapps.user ? cleverapps.user.cheater : undefined
    };

    if (cleverapps.user && connector.platform.getUserID()) {
        params.id = connector.platform.getUserID();
    }

    if (cleverapps.config && ["merge", "merge2", "farm"].includes(cleverapps.config.type) && cleverapps.user) {
        params.level = cleverapps.user.currentPhysicalLevel.level;
    }

    return params;
};

MetricsLogger.SEND_EVENTS_INTERVAL = cleverapps.parseInterval("1 minute");

MetricsLogger.IMPORTANT_EVENTS = [
    cleverapps.EVENTS.STATS.PAYMENTS,
    cleverapps.EVENTS.SUBSCRIPTION_BOUGHT,
    cleverapps.EVENTS.STATS.LEVEL_FINISH
];